import { render, staticRenderFns } from "./UnitInput.vue?vue&type=template&id=671b03b9&scoped=true"
import script from "./UnitInput.vue?vue&type=script&lang=js"
export * from "./UnitInput.vue?vue&type=script&lang=js"
import style0 from "./UnitInput.vue?vue&type=style&index=0&id=671b03b9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "671b03b9",
  null
  
)

export default component.exports